var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesforceSwevenImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: #949bff;\n      }\n\n      .cls-3 {\n        fill: #b8bcff;\n      }\n\n      .cls-4 {\n        fill: #d6d9ff;\n      }\n\n      .cls-5 {\n        fill: #adcfff;\n      }\n\n      .cls-6 {\n        fill: #3c3d7d;\n      }\n\n      .cls-7 {\n        fill: #ffc3a8;\n      }\n\n      .cls-16, .cls-26, .cls-7 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-8 {\n        fill: #4f50a6;\n      }\n\n      .cls-9 {\n        fill: #1d1d52;\n      }\n\n      .cls-10 {\n        fill: #9d9df2;\n      }\n\n      .cls-11 {\n        fill: #b8d5ff;\n      }\n\n      .cls-12 {\n        fill: #86a5ff;\n      }\n\n      .cls-13 {\n        fill: #6b84cc;\n      }\n\n      .cls-14 {\n        fill: #586da8;\n      }\n\n      .cls-15 {\n        fill: #ccd9ff;\n      }\n\n      .cls-17 {\n        fill: #cef;\n      }\n\n      .cls-18 {\n        fill: #f08a73;\n      }\n\n      .cls-19, .cls-22 {\n        fill: #4f65a6;\n      }\n\n      .cls-20 {\n        fill: #5269ad;\n      }\n\n      .cls-21 {\n        fill: #617ccc;\n      }\n\n      .cls-22 {\n        mix-blend-mode: screen;\n      }\n\n      .cls-23 {\n        fill: #ff9b85;\n      }\n\n      .cls-24 {\n        fill: #e72552;\n      }\n\n      .cls-25 {\n        fill: #bf1e45;\n      }\n\n      .cls-26 {\n        fill: #d1d1d1;\n      }\n\n      .cls-27 {\n        fill: #402a2a;\n      }\n\n      .cls-28 {\n        fill: #593b3b;\n      }\n\n      .cls-29 {\n        fill: #2b1c1c;\n      }\n\n      .cls-30 {\n        fill: #9c1937;\n      }\n\n      .cls-31 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.48,60.33c9.61,3.84,9.46,6.37,12.11,9.39s8.12-.09,8.44,6.11-6.36,3,1.63,9.06,12.49,8.69,10.75,13.29.19,7.23,1.46,11.74.9,5.06-.37,8.22-2.8,2.07-3.51,1.68S36.17,91.53,34.68,90.15,17.48,60.33,17.48,60.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44,102.68C35.69,75.25,17.48,60.33,17.48,60.33c2.73,7.38-.57,11.19,1.46,14.29s5.88,1.15,4.19,6.51-5.37,8.52-.26,11.08,6.88.22,5.09,6.46.62,10,4.83,11.24,5.91.85,5.52,4.11a4.56,4.56,0,0,0,4.2,5.15c2.07.25,5.39,1.39,5.48.65S44,102.68,44,102.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.43,128.26l-.16,0,.07-.32.15,0c9.77,1.84,13-6,16.66-15.17,3.13-7.72,6.68-16.48,15.14-19.68l.11.31c-8.32,3.14-11.69,11.46-14.94,19.5-1.85,4.55-3.59,8.86-6.15,11.8C167.46,128,164,129.12,159.43,128.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.29,93.09c4-.39,5.12.19,5.6.49C192.68,97,190.76,94.32,191.29,93.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.85,95.73c4-.4,5.12.19,5.61.49C188.25,99.66,186.32,97,186.85,95.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.77,95.17c1.61-2.27,1.63-3.14,1.62-3.53C185.89,93,186.86,95.07,187.77,95.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.78,98.69c1.1-2.55.94-3.4.85-3.79C181.49,97,182.86,98.78,183.78,98.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.34,102.07c.4-2.75,0-3.53-.16-3.88C178.68,101,180.49,102.4,181.34,102.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.11,106.41c.39-2.76,0-3.54-.17-3.88C176.44,105.32,178.25,106.73,179.11,106.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.87,111.32c0-2.79-.47-3.51-.71-3.82C174.08,110.62,176.07,111.76,176.87,111.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.92,116.3c0-2.79-.48-3.51-.72-3.82C172.13,115.6,174.11,116.74,174.92,116.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.58,121.14c0-2.78-.47-3.5-.71-3.81C169.8,120.45,171.78,121.59,172.58,121.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.37,125.42c.47-2.74.12-3.53-.07-3.88C166.74,124.28,168.51,125.73,169.37,125.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.47,99.2c4-.4,5.12.19,5.61.49C184.87,103.12,183,100.42,183.47,99.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.23,102.46c4-.4,5.11.19,5.6.49C182.62,106.38,180.7,103.68,181.23,102.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.93,106.42c4-.4,5.12.19,5.6.49C180.33,110.35,178.4,107.64,178.93,106.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177,111.33c4-.39,5.11.19,5.6.49C178.39,115.26,176.47,112.56,177,111.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175,116.23c4-.4,5.12.19,5.61.49C176.38,120.15,174.45,117.45,175,116.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.57,121c4-.4,5.12.19,5.61.49C174,124.93,172,122.23,172.57,121Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.31,125.63c4-.4,5.12.19,5.61.49C170.71,129.55,168.78,126.85,169.31,125.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.58,126.14l.16,0-.07-.32-.15,0c-9.77,1.84-13-6-16.66-15.17C18.73,102.92,15.18,94.16,6.72,91l-.11.31c8.32,3.14,11.69,11.45,14.94,19.5,1.85,4.55,3.59,8.85,6.15,11.8C30.55,125.87,34,127,38.58,126.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6.72,91c-4-.4-5.11.19-5.6.49C5.33,94.9,7.25,92.19,6.72,91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.16,93.61c-4-.4-5.12.19-5.61.49C9.76,97.53,11.69,94.83,11.16,93.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.24,93.05c-1.61-2.28-1.63-3.14-1.62-3.53C12.12,90.87,11.15,93,10.24,93.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14.23,96.57c-1.1-2.56-.94-3.4-.84-3.79C16.52,94.83,15.15,96.66,14.23,96.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.67,100c-.4-2.76,0-3.53.16-3.88C19.33,98.87,17.53,100.28,16.67,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.9,104.29c-.39-2.76,0-3.54.17-3.88C21.57,103.2,19.76,104.61,18.9,104.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.14,109.19c0-2.78.47-3.5.71-3.81C23.93,108.5,21.94,109.64,21.14,109.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.1,114.17c0-2.78.47-3.5.71-3.81C25.88,113.48,23.9,114.62,23.1,114.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.43,119c0-2.78.47-3.5.71-3.81C28.22,118.33,26.23,119.47,25.43,119Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.64,123.3c-.47-2.74-.12-3.53.07-3.88C31.27,122.15,29.5,123.61,28.64,123.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14.54,97.08c-4-.4-5.12.18-5.61.49C13.14,101,15.06,98.3,14.54,97.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.78,100.34c-4-.4-5.11.18-5.6.49C15.39,104.26,17.31,101.56,16.78,100.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.08,104.3c-4-.4-5.12.19-5.6.49C17.68,108.22,19.61,105.52,19.08,104.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21,109.21c-4-.4-5.12.19-5.61.49C19.62,113.14,21.54,110.43,21,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23,114.11c-4-.4-5.12.19-5.61.49C21.63,118,23.56,115.33,23,114.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.44,118.89c-4-.4-5.12.19-5.61.49C24,122.81,26,120.11,25.44,118.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.7,123.51c-4-.4-5.12.18-5.61.49C27.3,127.43,29.23,124.73,28.7,123.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.5,86l-.24.07-.14-.5.24-.07c15.12-4.16,14.18-17.54,13.09-33-.93-13.12-2-28,7.79-38.37l.38.35C130,24.65,131,38.76,132,52.41c.55,7.73,1.06,15-.52,21C129.68,80,125.56,84,118.5,86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.24,14.08c5.41-3.35,7.38-3.29,8.28-3.2C143.94,18.67,139.34,16.17,139.24,14.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.79,20.89c5.41-3.35,7.38-3.28,8.28-3.19C139.49,25.48,134.89,23,134.79,20.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.7,19.46c.7-4.34.14-5.58-.16-6.13C131.53,17.67,134.33,20,135.7,19.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.49,27.21c-.22-4.38-1-5.47-1.43-5.95C128,26.34,131.26,28,132.49,27.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.38,33.69c-1.35-4.18-2.41-5-2.92-5.38C126.86,34,130.39,34.74,131.38,33.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.22,41.38c-1.35-4.18-2.41-5-2.93-5.38C126.7,41.69,130.23,42.44,131.22,41.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.46,49.88c-1.93-3.94-3.1-4.63-3.66-4.91C127,50.83,130.63,51.07,131.46,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.14,58.29c-1.93-3.94-3.1-4.63-3.66-4.91C127.7,59.24,131.31,59.48,132.14,58.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.2,66.77c-1.93-3.94-3.11-4.63-3.66-4.91C127.76,67.72,131.37,68,132.2,66.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.61,75.06c-1.24-4.2-2.28-5.08-2.79-5.44C126.09,75.26,129.6,76.1,130.61,75.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.41,28.14c5.41-3.35,7.38-3.28,8.28-3.19C137.11,32.73,132.51,30.24,132.41,28.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.48,34.32c5.41-3.35,7.38-3.29,8.28-3.2C136.18,38.91,131.58,36.41,131.48,34.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131,41.52c5.42-3.34,7.39-3.28,8.29-3.19C135.68,46.11,131.08,43.62,131,41.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.64,49.82c5.41-3.35,7.38-3.28,8.28-3.19C136.34,54.41,131.74,51.92,131.64,49.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.18,58.15c5.42-3.34,7.39-3.28,8.29-3.19C136.89,62.74,132.29,60.25,132.18,58.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.08,66.59c5.42-3.34,7.39-3.28,8.28-3.19C136.79,71.18,132.18,68.69,132.08,66.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.67,75.4c5.41-3.35,7.38-3.29,8.28-3.2C135.37,80,130.77,77.49,130.67,75.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149,125.18c15.21-40.52,39.49-59.51,50.24-60.87-7.1,3.3-9,7.41-9.35,13.67s-.81,8-6.78,9.42-6.09,3.58-7,12-.28,11.07-6.38,13.56-7.13,0-8.09,8-9.09,9.41-9.09,9.41Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.8,38c-13.68.08-20,6.8-20,6.8l-1.27,2.9.39-3.14c-10.21,5-13.42,12.91-13.42,12.91l-1.3,10.2.59-9.7c-5.94,3.48-14.06,20.39-15.14,26.71.76,7.87,2.33,11.78,2.33,11.78l-3.56-9.68c-4.27,8.34-5.15,26-5.15,26l1.34,2.34-1.93-1.58c-.77,3.5,1.14,9.25,1.14,9.25l4.82,1,15-41,18.56-33.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M141.6,123.75C152.5,65.48,174.5,40.89,192.8,38c-2.53,4.41-6.86,13.67-6.86,13.67-4.69-3.15-7.7-2.12-7.7-2.12,6.62,3,7,4.12,7,4.12a89.33,89.33,0,0,1-6.89,13.77L173,66.1l4.69,3.84c-2.87,10.12-6.1,22.23-8.54,25.62-8.31-5.06-12.95-4.25-12.95-4.25,10.36,3.77,12.39,5.61,12.39,5.61-1.1,6.77-8.45,19.49-12.46,22.45-6-4.07-7.18-4.06-6.91-4a61.65,61.65,0,0,1,5.94,4.41,19,19,0,0,1-8.32,7.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.73,68l-.14.25c2.29-.46,9.42-1.27,17.27,4.47l.07-.23C169.24,66.87,162.23,67.5,159.73,68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.46,67.23c-2.1-1.51-6.26-3.73-14.45-6.49l-.12.19c8.23,2.77,12.37,5,14.45,6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.82,78.15l-.1.24a30.47,30.47,0,0,1,19.63,3.11l.06-.22A30.69,30.69,0,0,0,154.82,78.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.06,71.19c9.93,1.53,15.18,4.86,17.35,6.63l.07-.23c-2.24-1.8-7.51-5.09-17.32-6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.86,111.58a33.76,33.76,0,0,0-14.88-11l-.06.22a33.59,33.59,0,0,1,14.76,10.95l.25.35a2.39,2.39,0,0,0,.13-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.85,97.56l-.07.25a29.38,29.38,0,0,1,19.93,2.35c0-.08,0-.15.07-.22A29.64,29.64,0,0,0,147.85,97.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.39,81.59a1.8,1.8,0,0,0-.08.21c11.69,2.14,16.48,7,18,9l.09-.24C169.76,88.47,164.9,83.7,153.39,81.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.53,53.22l-.16.2C177.2,55,181,58.18,182.52,59.84l.11-.21C181.05,57.92,177.23,54.78,169.53,53.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.82,43.56l-.35.24a24.18,24.18,0,0,1,9.58,1.43l.1-.2A24.43,24.43,0,0,0,179.82,43.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.5,46.13l-.35.3a26.23,26.23,0,0,1,12,.6l.1-.2A26.74,26.74,0,0,0,176.5,46.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167,56.42l-.15.2a28.3,28.3,0,0,1,13.52,7.28c0-.07.07-.14.11-.2A28.59,28.59,0,0,0,167,56.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.38,42.52c-.17.1-.33.21-.49.32,4.5-.88,7.51-.48,9.31.08l.12-.22A18.85,18.85,0,0,0,181.38,42.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186.63,50.24c-1.83-1.23-5.3-2.81-11.31-3.08l-.23.21c6.14.25,9.63,1.84,11.44,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.52,50.94c-.06.08-.13.15-.2.23a18.56,18.56,0,0,1,13.08,4.57l.09-.22A18.76,18.76,0,0,0,171.52,50.94Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.71,37.49c9.81-1.23,15,3,15,3l1.17,2-.57-2.22c7.79,2.61,10.83,8,10.83,8L43,55.42l-1.33-6.9c4.58,1.94,12,13.3,13.35,17.73a34.29,34.29,0,0,1-.56,8.66l1.64-7.27c3.84,5.58,6.12,18.13,6.12,18.13l-.74,1.8,1.23-1.3c.88,2.43,0,6.73,0,6.73l-3.36,1.15-14.6-28L28.39,43.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.44,94.15C46.17,53.4,28.1,37.83,14.71,37.49c2.23,2.92,6.2,9.15,6.2,9.15C24,44,26.23,44.4,26.23,44.4,21.77,47.16,21.62,48,21.62,48a65.14,65.14,0,0,0,6.23,9.23l3.72-1.48-3,3.19c3,7,6.45,15.36,8.52,17.57C42.57,72.11,46,72.26,46,72.26c-7.08,3.67-8.37,5.18-8.37,5.18,1.43,4.75,7.89,13.18,11,14.92,3.89-3.47,4.77-3.58,4.58-3.5a45.26,45.26,0,0,0-3.84,3.72,13.75,13.75,0,0,0,6.68,4.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.22,55.86l.12.17c-1.68-.12-6.86,0-12,4.81l-.07-.15C34.31,56,39.39,55.75,41.22,55.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.73,57.08c1.36-1.28,4.14-3.26,9.74-6l.11.12c-5.64,2.76-8.4,4.75-9.74,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.69,62.7l.1.16A22,22,0,0,0,32,66.93l-.07-.15A22.15,22.15,0,0,1,45.69,62.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.72,58c-7,2-10.42,4.91-11.82,6.38l-.07-.16c1.44-1.5,4.91-4.35,11.8-6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.78,87.32A24.4,24.4,0,0,1,53.41,78s0,.09.06.15a24.34,24.34,0,0,0-9.55,9.22l-.15.28-.11-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.51,76l.07.17a21.28,21.28,0,0,0-14.07,3.55,1,1,0,0,0-.07-.15A21.44,21.44,0,0,1,52.51,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47,65l.08.14C38.94,67.8,36,71.74,35.05,73.35L35,73.18C36,71.49,39,67.62,47,65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.81,46.2l.14.13c-5.47,1.85-7.9,4.5-8.83,5.83L24,52C25,50.65,27.45,48,32.81,46.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.54,40.24l.27.14a17.55,17.55,0,0,0-6.73,1.92L18,42.17A17.68,17.68,0,0,1,24.54,40.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.16,41.77l.28.18a19,19,0,0,0-8.56,1.56l-.09-.13A19.42,19.42,0,0,1,27.16,41.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.92,48.26l.12.13a20.47,20.47,0,0,0-9,6.48l-.1-.13A20.77,20.77,0,0,1,34.92,48.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.32,39.64l.38.18a14.11,14.11,0,0,0-6.67.93l-.1-.15A13.74,13.74,0,0,1,23.32,39.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.28,45.67c1.2-1.06,3.54-2.51,7.82-3.27l.19.13c-4.38.75-6.74,2.22-7.92,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.17,44.76l.17.14a13.45,13.45,0,0,0-8.95,4.5,1.09,1.09,0,0,1-.08-.15A13.55,13.55,0,0,1,31.17,44.76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.78,143.54h76.88c-8.51-11.19-24.29-24.1-39.06-24.33s-11-8.28-32.44-11-68.55,10.71-74,15.2-19.09,13.82-25.81,20.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 86.39,
    y: 105.03,
    width: 19.03,
    height: 16.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.43 121.4 86.39 109.79 105.43 105.03 105.43 121.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M111.14,121.4H80.68a4.32,4.32,0,0,0-4.31,4.32h39.08A4.32,4.32,0,0,0,111.14,121.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 39.97,
    y: 41.13,
    width: 108.24,
    height: 68.65,
    rx: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 60.79,
    y: 22.36,
    width: 66.59,
    height: 106.19,
    rx: 1.76,
    transform: "translate(169.54 -18.64) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 69.11,
    y: 23.39,
    width: 49.96,
    height: 104.13,
    transform: "translate(169.54 -18.64) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 48.28,
    y: 41.73,
    width: 51.25,
    height: 56.39
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.22,
    y: 47.34,
    width: 15.15,
    height: 15.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M65.5,59.89a4.08,4.08,0,0,0-2.06-2.28l-3.75-1.82H58l-3.76,1.82a4.15,4.15,0,0,0-2.06,2.28l-1,2.6H66.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M55.91,51C55,50.33,57,47.88,60,50c.8.56.26,4.64-.72,4.69S55.91,51,55.91,51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M56.1,50.31c1.35.25,1.64,0,1.64,0,.18.51,1.13.37,1.13.37s-.44,2.5.78,2.36a21.72,21.72,0,0,1,.09,2.63,1.17,1.17,0,0,1-.54,1c-1.64,1.06-2,.22-2.08-.14-.09-.57.2-1.06-.09-1.06-.9-.32-1.15-.86-1.15-2.32s-.1-2.36.06-2.36S56.1,50.31,56.1,50.31Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 59.84,
    cy: 53.11,
    r: 0.63
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 92.25,
    y: 41.73,
    width: 51.25,
    height: 56.39
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 112.75,
    y: 46.14,
    width: 15.15,
    height: 15.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M127,58.69A4.15,4.15,0,0,0,125,56.41l-3.76-1.82h-1.67l-3.76,1.82a4.1,4.1,0,0,0-2.05,2.28l-1,2.6h15.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M117.44,49.78c-.88-.65,1.08-3.1,4.11-1,.8.56.26,4.64-.71,4.69S117.44,49.78,117.44,49.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M117.63,49.11c1.36.25,1.65,0,1.65,0,.17.51,1.12.37,1.12.37s-.44,2.5.79,2.36a20,20,0,0,1,.08,2.63,1.19,1.19,0,0,1-.53,1c-1.65,1.06-2,.22-2.09-.14-.08-.57.21-1.06-.08-1.06-.91-.32-1.16-.86-1.16-2.32s-.1-2.36.06-2.36C117.78,49.52,117.63,49.11,117.63,49.11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 121.38,
    cy: 51.91,
    r: 0.63
  })), /*#__PURE__*/React.createElement("image", {
    className: "cls-16",
    width: 85,
    height: 236,
    transform: "translate(122.88 41.76) scale(0.24)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-16",
    width: 85,
    height: 236,
    transform: "translate(51.6 41.76) scale(0.24)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 71.68,
    y: 30.07,
    width: 51.25,
    height: 68.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 74.94,
    y: 64.27,
    width: 43.62,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 74.94,
    y: 72.24,
    width: 43.62,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 74.94,
    y: 80.21,
    width: 43.62,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 74.94,
    y: 90.75,
    width: 43.62,
    height: 1.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M164.1,81.52c1.05,3.49,3.14,14.93,3.14,15.09a3.49,3.49,0,0,1-1.78-.06c-.05-.15-2.92-10.44-3-10.7S164.1,81.52,164.1,81.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M184.89,107h0a3.61,3.61,0,0,1-4.66,2.07L136.52,92.24l2.59-6.73,43.71,16.83A3.61,3.61,0,0,1,184.89,107Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M139.32,90a24.36,24.36,0,0,1-45,1.14,24.29,24.29,0,0,1-.47-18.64A24.36,24.36,0,1,1,139.32,90ZM95.76,73.19a22.32,22.32,0,1,0,28.85-12.81A22.33,22.33,0,0,0,95.76,73.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M138.65,91.72a24.34,24.34,0,1,1-5.82-26.3,24.55,24.55,0,0,1,5.35,7.66,24.29,24.29,0,0,1,.47,18.64ZM95.08,74.94a22.33,22.33,0,1,0,28.85-12.81A22.36,22.36,0,0,0,95.08,74.94Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 115.91,
    cy: 82.96,
    r: 22.32,
    transform: "translate(-8.06 153.32) rotate(-65.17)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M163.37,105.8l-4.85,3.7s-.84,14.21-1.41,15.3-.89,3.36-1.64,3.54c0,.48,1,.54,1.25.48a4.69,4.69,0,0,0,1.15-1.29c0-.17,1-2.41,1-2.41-.42-1.41,3.18-11.44,3.55-13S163.37,105.8,163.37,105.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M163.37,105.8l-4.47,3.41c0,2.64.25,11.71.26,13.47.86-3.49,3-9.38,3.22-10.51C162.75,110.65,163.37,105.8,163.37,105.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M157.21,106.94s5.07,17.44,4.91,18.54-.31,2.56-.63,2.72-1.72.52-1.3.73,3.25.28,3.36-.21.38-2.26.83-2.13.52,2.2.52,2.2l.28-.11s0-2.64-.1-3-.77-.34-1.08-1.18-.94-12.22-1.36-14.58a9.78,9.78,0,0,0-1.77-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M162.64,109.89a9.78,9.78,0,0,0-1.77-4l-3.66,1.09s0,.16.13.46l5.49,3.95C162.76,110.72,162.7,110.22,162.64,109.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M155.49,91.75c-1.93,8.72-.94,9.71.68,15.46a20.92,20.92,0,0,0,8.51-.42c-.05-4.81.57-8.83-.52-11.44a59.12,59.12,0,0,1-2-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M157.84,103.82a52.74,52.74,0,0,1-.13-12.48l-.16,0a52.51,52.51,0,0,0,.14,12.53c.21,1.56.46,2.79.65,3.62h.16C158.31,106.65,158.06,105.41,157.84,103.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M158.33,81.1c-1.67,3.26-3.23,3.76-3.39,4.38s1,2.85,1.2,4,.39,2.59.39,2.59l6.41,0a25,25,0,0,1,1.27-7.47,9.46,9.46,0,0,0,.15-5l-5-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M160.74,92c.93,1.7,1.07,11.12,1.09,15.28a22.53,22.53,0,0,0,2.85-.53c-.05-4.81.57-8.83-.52-11.44-.46-1.08-.88-2.29-1.23-3.34h0a25,25,0,0,1,1.27-7.47,9.46,9.46,0,0,0,.15-5l-.62,0-1.39.93C163.42,85.09,160.55,92,160.74,92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M159.66,81.05c-1.87-.06-3.34,7.31-4.85,8.72s-4.39,5.53-4.81,5.32a2.28,2.28,0,0,0-1.48-.34c-.39.16-1.13-.08-1.23,0s-.18.63.37.7.94.08.91.37-.86,1.36-.55,1.64.5,0,.86,0,1.28.52,1.83,0,.55-1.17.76-1.51,6.18-4.33,6.45-4.88,3.18-6.5,3.55-7.78A1.67,1.67,0,0,0,159.66,81.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M165.64,77.49c-1.64-1.35-.7-2.48-1.75-4.49s-3.76-2.37-6.13-1.67c-1.15-.15-.81,1.91-.13,1.83l0,1S159.58,78.09,159,79s-2.06,1.28-1.88,2.43h1.29a2.26,2.26,0,0,1,1.26-1.51,2.39,2.39,0,0,0-.72,1.51h1.17a3.07,3.07,0,0,1,.13-.64l.05.64h1a3,3,0,0,0-.11-1.08,4.14,4.14,0,0,1,.38,1.08h4a3.68,3.68,0,0,0-.39-2.26,4.33,4.33,0,0,1,.61,2.26h1.24S167.29,78.85,165.64,77.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M157.7,74.53a1.47,1.47,0,0,1-.75.81,1.6,1.6,0,0,0,.77.6C157.94,75.93,157.7,74.53,157.7,74.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M157.7,74.53a1.47,1.47,0,0,1-.75.81,1.6,1.6,0,0,0,.77.6C157.94,75.93,157.7,74.53,157.7,74.53Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M159.47,75.49a.6.6,0,1,1-.67-.52A.59.59,0,0,1,159.47,75.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M158.84,75.22a.39.39,0,0,0-.33.44h.05a.33.33,0,0,1,.2-.35h0a.21.21,0,0,1,.22.17.2.2,0,0,1-.17.22v0a.24.24,0,0,0,.22-.28.27.27,0,0,0-.14-.19.33.33,0,0,1,.33.3h.06A.41.41,0,0,0,158.84,75.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M159,75.7c-.21.34-.51.12-.58-1-.33-.1-.63-.86-.78-1.88a8.47,8.47,0,0,0-.17,2.19,10.61,10.61,0,0,0,.07,2.21c.2,1,.6,1.1,1.05.9s.42.12.4.89A3.62,3.62,0,0,0,159,75.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M167.87,81.45l-.2,0a5.93,5.93,0,0,0-.51-3.2,4.93,4.93,0,0,0-1.35-1.61,5.69,5.69,0,0,1-1.72-2.22l.19-.08A5.54,5.54,0,0,0,166,76.45a5,5,0,0,1,1.39,1.68A5.91,5.91,0,0,1,167.87,81.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M158.59,77.46h0a3.73,3.73,0,0,0,.46-1.38l0,0a0,0,0,0,0,0,0,3.43,3.43,0,0,1-.46,1.35.06.06,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M167.3,81.45l-.21,0a5.82,5.82,0,0,0-.51-3.2,4.93,4.93,0,0,0-1.35-1.61,5.88,5.88,0,0,1-1.72-2.22l.19-.08a5.54,5.54,0,0,0,1.67,2.14,5,5,0,0,1,1.4,1.68A6,6,0,0,1,167.3,81.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M156.9,91.16h-.16s0,0,0,0,0,0,0,0a.59.59,0,0,0,.57-.15.65.65,0,0,0,.11-.6s0,0,0,0,0,0,0,0a.69.69,0,0,1-.12.65A.6.6,0,0,1,156.9,91.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M164.47,125.12c-.89,1.18-1.3,3-2,3.22a2.94,2.94,0,0,1-1.32,0c-.51.18-1.24.43-.92.59s3.25.28,3.36-.21.38-2.26.83-2.13.52,2.2.52,2.2l.28-.11s0-2.64-.1-3C165,125.42,164.75,125.34,164.47,125.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M158.83,125.12c-.89,1.18-1.3,3-2,3.22a2.94,2.94,0,0,1-1.32,0c-.51.18-1.24.43-.92.59s3.25.28,3.36-.21.38-2.26.83-2.13.52,2.2.52,2.2l.28-.11s0-2.64-.1-3C159.4,125.42,159.11,125.34,158.83,125.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M63,108.16c.26,1.32-.63,3.86-.37,6.44s1.69,9.83,1.53,10.88-.58,1.24-.24,2a5.87,5.87,0,0,1,.43,1.54h.42V127.2c1,.58,1.13,1.74,1.56,1.85a20,20,0,0,0,2.53,0,8.29,8.29,0,0,0-1.27-.71,12.59,12.59,0,0,0-1.82-3c-.76-.84.85-13.39,1.27-14.71a8.78,8.78,0,0,0,.32-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M67.28,109.15a8.49,8.49,0,0,0,0-1.16L66,107.87l-3,.29c.21,1-.31,2.85-.4,4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M64.73,129.05V127.2c1,.58,1.13,1.74,1.56,1.85a20,20,0,0,0,2.53,0,4.93,4.93,0,0,0-1.13-.63,2.05,2.05,0,0,1-1.07,0c-.79-.27-1.06-1.91-2.61-2.38-.18.64-.41.88-.13,1.52a5.87,5.87,0,0,1,.43,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M68.33,108.16c.27,1.32-.3,3.86,0,6.44s2.91,9.83,2.75,10.88-.58,1.24-.24,2a6.07,6.07,0,0,1,.42,1.54h.43V127.2c.95.58,1.13,1.74,1.55,1.85a20.16,20.16,0,0,0,2.54,0,8.79,8.79,0,0,0-1.27-.71,12.92,12.92,0,0,0-1.82-3c-.77-.84-.7-13.39-.28-14.71a8.47,8.47,0,0,0,.32-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M72.69,107.74l-4.36.42c.24,1.19-.2,3.35-.1,5.65l4.44-4.87A8.07,8.07,0,0,0,72.69,107.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M62.31,84.58c-1.23,5-2.85,8,3.83,6.69,4.48-3.21-2-11.13-2-11S62.31,84.58,62.31,84.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M70,79.39l.46,0,3.24,4.34s-1.11,2-1.58,3.09.23,3.67-.61,3.83H64.89c.1-1-.48-4.72-.74-7.26s.6-4.12,1.69-4.12S70,79.39,70,79.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M69.63,78.33a1.69,1.69,0,0,1,.4,1.06H65.56L66,78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M66,76.74c-1.54-1.54-1.7-4.23-.59-5.16s2.64-.7,3.23-1.3,1.61-.3,2,.89a3.59,3.59,0,0,1-.37,2.5c0,.11-.81,2.92-.86,3s-2.26,1.1-2.26,1.1-1.14,0-1.14-.05S66,76.74,66,76.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M70.64,73.59a1.54,1.54,0,0,0,.88.74c.06,0-.5.69-.72.72S70.64,73.59,70.64,73.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M70.64,73.59a1.54,1.54,0,0,0,.88.74c.06,0-.5.69-.72.72S70.64,73.59,70.64,73.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M70.45,71.79c0,1.07-.23,1.9-.56,2C70,75,69.7,75.29,69.43,75c.2,1.47-1.85,2-3,1.93a2,2,0,0,1-.26,1.59c1.07.52,3.31.47,3.52,0-.13-.8,0-1.25.49-1.11s.88-.06,1-1.08A11.3,11.3,0,0,0,70.92,74,8.79,8.79,0,0,0,70.45,71.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M70.11,76.73s0,0,0,0a3.65,3.65,0,0,1-.66-1.35.05.05,0,0,1,0,0s0,0,0,0a3.72,3.72,0,0,0,.65,1.34,0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M68.94,74.81a.63.63,0,1,0,.62-.62A.63.63,0,0,0,68.94,74.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M69.55,74.46a.4.4,0,0,1,.4.4h0a.34.34,0,0,0-.25-.33h0a.2.2,0,0,0-.2.2.2.2,0,0,0,.2.21v0a.26.26,0,0,1-.26-.26.24.24,0,0,1,.12-.21.35.35,0,0,0-.31.34h0A.4.4,0,0,1,69.55,74.46Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M58.39,86.49h-.33a3.08,3.08,0,0,1,.52-3.08,2.06,2.06,0,0,0,.77-1.53,4.12,4.12,0,0,1,.21-1.09c.39-1.1,1.81-1.58,3.33-2.08l1-.34.11.3c-.33.12-.67.24-1,.34-1.43.48-2.79.93-3.12,1.89a3.62,3.62,0,0,0-.2,1,2.33,2.33,0,0,1-.85,1.72,2.86,2.86,0,0,0-.43,2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M81.6,69.56c-2.11,1.9-7.45,7.29-8.77,8.29a18.59,18.59,0,0,1-2.32,1.54A4.12,4.12,0,0,0,72,84.93c1.53.69,6.55-5.76,8.29-8.71a25.68,25.68,0,0,0,2.48-5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M70.69,83.74h0a4.49,4.49,0,0,1-.18-4.36,0,0,0,0,1,0,0s0,0,0,0a4.45,4.45,0,0,0,.18,4.3,0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M81.6,69.56a27.48,27.48,0,0,1,1.88-2.37,14.57,14.57,0,0,1,1.68-1.07c.1,0,.27.18,0,.53s-.74.83-.57,1.2A1.4,1.4,0,0,1,84.65,69a2.35,2.35,0,0,1-1.06,1,6.73,6.73,0,0,0-.78.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 64.89,
    y: 90.63,
    width: 6.69,
    height: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M64.89,91.42C61.18,97.71,62,108.76,62,108.76H74.87c0-6.93-1.9-15-3.29-17.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M72.18,108.76h.11A70.05,70.05,0,0,0,70.6,94.05a3,3,0,0,0,.62-2.63h-.1a3.18,3.18,0,0,1-.54,2.5c-.18-.81-.37-1.64-.57-2.5H69.9A73.21,73.21,0,0,1,72.18,108.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M71.65,129.05V127.2c.95.58,1.13,1.74,1.55,1.85a20.16,20.16,0,0,0,2.54,0,4.93,4.93,0,0,0-1.13-.63,2,2,0,0,1-1.07,0c-.79-.27-1.06-1.91-2.61-2.38-.18.64-.41.88-.13,1.52a6.07,6.07,0,0,1,.42,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M68.23,91.42v-.79h-.84a6.73,6.73,0,0,0,.1-4.11,15,15,0,0,1,.38-6.7.84.84,0,0,1,0-.95s-.29-1.91-.32-2.32l-1.16.16-.82,2.57c-1,.22-1.7,1.75-1.45,4.09.26,2.54.84,6.26.74,7.26v.79C61.18,97.71,62,108.76,62,108.76H66.6C66.81,105,67.57,92.13,68.23,91.42Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 66.63,
    cy: 75.98,
    r: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M65.72,82a4.22,4.22,0,0,0,1.14-3.89c-.35-1.28-.23-1.54-.07-1.76a.33.33,0,0,0-.08-.46.44.44,0,0,0-.65.14,6.24,6.24,0,0,1-3,2.58c-1.62.49-2.5,1.18-2.48,2.07s.21,1.66-.58,2.36a4,4,0,0,0-1.09,3.42H60A5,5,0,0,1,60.54,84a7.15,7.15,0,0,0-.29,2.51h1c0-.28.07-.58.07-.58l.07.58h.33a2.88,2.88,0,0,0,.07-1.08,2.44,2.44,0,0,1,.06,1.08h2.14a4,4,0,0,0-.14-2,4.83,4.83,0,0,1,.29,2h.35A3.16,3.16,0,0,0,64.08,84a1.87,1.87,0,0,1,1-2.32,1.87,1.87,0,0,0-.7,2.23A3.62,3.62,0,0,1,65,86.49h1a3.14,3.14,0,0,0-.37-2A1.55,1.55,0,0,1,65.72,82Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M40.26,127.4a2.54,2.54,0,0,0-.1,1.69H48c.25-1.49-5.21-3.21-5.21-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M40.07,128.53a2.06,2.06,0,0,0,.09.56H48a.79.79,0,0,0-.15-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M47.25,105.13c-.65,6.35-4.49,18.42-4.49,19.18s.22.38.33.7.16.6.49.66.32.65-.22,1a4.51,4.51,0,0,0-2,1.25,1.83,1.83,0,0,1-1.73.38c-.44-.22.75-26.25.79-27.48a21,21,0,0,1,1.9-8.28l5,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M46.29,127.4a2.58,2.58,0,0,0-.11,1.69h7.87c.26-1.49-5.21-3.21-5.21-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M46.09,128.53a2.67,2.67,0,0,0,.09.56h7.87a.74.74,0,0,0-.15-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M44.06,96.08s.06,3.75,1,4.51.16,27.46.59,27.68a1.85,1.85,0,0,0,1.74-.38,4.53,4.53,0,0,1,2-1.25c.55-.32.55-.92.22-1s-.38-.33-.49-.66-.32.06-.32-.7,2.44-13,3.09-19.38a39.4,39.4,0,0,0-.22-10.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M40.43,84.63c.78,3.38,1,11.6,1,11.6,4.38,1.44,10.06.94,11.22.1-.29-3.76-.94-6.18-.44-8.68a45.7,45.7,0,0,0,.69-5.36l-1.45-4.88c-2-.46-2.77-.57-2.77-.57a22.24,22.24,0,0,0-7.52.19c-.76.25-1.87,2-1.87,2s-.9,5-.83,5S40.43,84.63,40.43,84.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M40.86,94.9c-.2.84-.7.95-.74,1.11s.49.56.89,0S40.86,94.9,40.86,94.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M41.55,93.08c.9.33,1.14.54,1.24,1.17s.22,2.59-.15,2.66c-.22,1-.35,1.13-.54,1.07-.37.38-.59.11-.59.11-.36.33-.61,0-.66-.37a16.38,16.38,0,0,1-.06-2.47c.07-.55-.66-1.11-.66-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M41.57,92.86l.13.17a2.73,2.73,0,0,1-1.37,1.51l-.43-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M50,94.84c.62.26,1,.4,1.08.89a1.9,1.9,0,0,0,.63,1.21c.24.09-.12.62-.64.34s-.76-.62-.79-.48-.44,3.49-.77,3.6-.48-.27-.48-.27c-.31.17-.61,0-.59-.22-.37,0-.49-.44-.48-.72-.36-.16-.31-.25-.32-1.09a18.46,18.46,0,0,1,.2-2.33s.19-.65.2-.71S50,94.84,50,94.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M47.57,95.47l.18.33a17.06,17.06,0,0,0,2.22-1l-.24-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M48.65,70.11a1.46,1.46,0,0,0-1-2.29,3.55,3.55,0,0,0-3.08,1.05c-.88.67-1.77,1.32-1.35,2.73a7.53,7.53,0,0,0,1.29,2.47c.08.12.21.66.42.68S48,74.57,48,74.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M48.89,71.4a1.61,1.61,0,0,0,1,.53,1.61,1.61,0,0,1-.55.86C49.15,72.86,48.89,71.4,48.89,71.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M48.84,72.39a.91.91,0,1,1,.91-.91A.91.91,0,0,1,48.84,72.39Zm0-1.71a.8.8,0,1,0,.8.8A.8.8,0,0,0,48.84,70.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M48.89,71.4a1.61,1.61,0,0,0,1,.53,1.61,1.61,0,0,1-.55.86C49.15,72.86,48.89,71.4,48.89,71.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M48.65,70.11c-.3,1.14-.72,1.37-.72,1.37.38,1.23-.54,1-.54,1s-.22.29-.19.45c0,.84-1.53,1.57-2.71,1.1,0,1,0,1.65,0,1.65l3.77.45,0-.76c.43,0,1.07-.11,1.19-1.41a4.06,4.06,0,0,0-.38-2.28C48.92,71.21,48.75,70.28,48.65,70.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M48,74.5h0a3.82,3.82,0,0,1-.65-1.36s0,0,0,0,0,0,0,0A3.55,3.55,0,0,0,48,74.46a0,0,0,0,1,0,0S48,74.5,48,74.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M46.79,72.58a.63.63,0,1,0,.63-.62A.63.63,0,0,0,46.79,72.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47.41,72.23a.4.4,0,0,1,.4.4h-.05a.34.34,0,0,0-.25-.33h0a.2.2,0,0,0-.21.2.21.21,0,0,0,.21.21v.05a.26.26,0,0,1-.26-.26.27.27,0,0,1,.11-.22.35.35,0,0,0-.3.35H47A.41.41,0,0,1,47.41,72.23Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 47.38,
    y: 71.42,
    width: 2.31,
    height: 0.11,
    transform: "translate(-17.18 15.39) rotate(-15.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M49,68.57a1.1,1.1,0,0,0-.59-.62,1.29,1.29,0,0,0-1.13,0l0,0a1.41,1.41,0,0,1,1.18,0,1.22,1.22,0,0,1,.62.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M43.55,76.7c-.14-.43.43-1,.84-1.11a22.68,22.68,0,0,1,4,.6c.22.16.28.65.28.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M51.48,77.41c-2.13.32-7.74,9.84-7.52,11.4s3.33,6.8,3.33,6.8a4.88,4.88,0,0,0,3-1.37c-.22-.8-1.41-4.49-1.41-4.49.18-.33-.26-.76-.26-.76.4-.07.4-.58.4-.58.62-.72,2.86-2.57,3.62-3.84S53.87,78,51.48,77.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M51.72,85.74h0c-.51.55-1.1,1.11-1.62,1.6s-.85.81-1.06,1v0s0,.48-.38.55a0,0,0,0,0,0,0,0,0,0,0,0,0,0s.41.42.24.72v0s1.19,3.68,1.41,4.48a5.06,5.06,0,0,1-3,1.34c-.18-.3-3.11-5.28-3.32-6.78-.12-.85,1.64-4.37,3.69-7.38,0,0,0,0,0,0s0,0,0,0c-1.86,2.73-3.84,6.45-3.7,7.42.21,1.54,3.3,6.76,3.33,6.81l0,0h0a4.82,4.82,0,0,0,3-1.4h0c-.21-.77-1.34-4.26-1.41-4.48.14-.29-.13-.64-.23-.75.34-.09.37-.51.37-.58.21-.24.6-.61,1.05-1s.68-.64,1-1a.8.8,0,0,1,.36.17h.05a.06.06,0,0,0,0-.06,1,1,0,0,0-.35-.17l.54-.56A0,0,0,0,0,51.72,85.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M49,100.1h0s0,0,0,0a16.59,16.59,0,0,1,.31-2.34s0,0,0,0,0,0,0,0a16.58,16.58,0,0,0-.31,2.33A0,0,0,0,1,49,100.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M48.43,99.88h0s0,0,0,0a16.88,16.88,0,0,1,.31-2.34s0,0,0,0,0,0,0,0a16.29,16.29,0,0,0-.31,2.33A0,0,0,0,1,48.43,99.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M41.5,98.08h0a0,0,0,0,1,0,0,17,17,0,0,1,0-2.35,0,0,0,1,1,.06,0,14.47,14.47,0,0,0,0,2.35S41.51,98.08,41.5,98.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M42.07,95.62a0,0,0,0,0,0,0A17.08,17.08,0,0,0,42,98v0l0,0a14.32,14.32,0,0,1,0-2.34A0,0,0,0,0,42.07,95.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M42.55,95.52a0,0,0,0,0,0,0,0,0,0,0,0,0,0,14.61,14.61,0,0,0,.11,1.58l0-.16C42.55,96.11,42.55,95.53,42.55,95.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M48.19,97.4s0,0,0,0a15.47,15.47,0,0,0-.27,1.75l0,0v.12a15.94,15.94,0,0,1,.28-1.87S48.21,97.41,48.19,97.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M41.17,77c-2.61,2.79-.87,7.45-.72,7.6a21.82,21.82,0,0,1-1.16,3.22s-.62.25-.15.4,0,.25.15.32a24.37,24.37,0,0,1,2.31,4.27,2.93,2.93,0,0,1-1.81,1.78c-.21-.11-5.71-5.14-5.89-6.15S39,78,39.5,77.62A4.88,4.88,0,0,1,41.17,77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M39.79,94.62s0,0,0,0,0,0,0,0a2.91,2.91,0,0,0,1.78-1.74,22.88,22.88,0,0,0-2.3-4.25s0,0-.05,0,0-.07.05-.1.06-.05,0-.07,0-.06-.19-.11-.19-.09-.19-.15.26-.26.33-.29a20.29,20.29,0,0,0,1.16-3.18,8.5,8.5,0,0,1-.68-2.83A6.16,6.16,0,0,1,41.15,77h0a0,0,0,0,1,0,0A6.17,6.17,0,0,0,39.8,81.8a8.5,8.5,0,0,0,.66,2.79,17.44,17.44,0,0,1-1.15,3.25h0c-.12.05-.31.16-.31.24s.06.08.16.11.21.09.22.14,0,.1-.06.13l0,0h0a24.89,24.89,0,0,1,2.32,4.28v0a3,3,0,0,1-1.83,1.79Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 75.04,
    y: 38.52,
    width: 20.2,
    height: 20.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M94.1,55.24a5.47,5.47,0,0,0-2.75-3l-5-2.44H84.11l-5,2.44a5.47,5.47,0,0,0-2.75,3l-1.28,3.48H95.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M82,50.79a16.52,16.52,0,0,0-1.94,7.93h5.16c.89-3.92,1.67-7.3,2.59-8.2l-1.51-.74H84.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M81.3,43.37c-1.19-.87-.52-1.4-.1-1.3.64-1,4.65-.93,5.58,0s.35,6.18-1,6.26S81.3,43.37,81.3,43.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M81.55,42.48c1.81.33,2.2,0,2.2,0,.23.68,1.49.48,1.49.48s-.58,3.35,1.05,3.15a28,28,0,0,1,.11,3.52,1.54,1.54,0,0,1-.71,1.27c-2.19,1.42-2.67.29-2.78-.18-.11-.76.27-1.42-.11-1.42-1.21-.43-1.54-1.15-1.54-3.09s-.13-3.15.08-3.15C81.75,43,81.55,42.48,81.55,42.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 86.55,
    cy: 46.21,
    r: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M81.67,47a1.14,1.14,0,0,0,2.27,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M119.22,36.5A1.45,1.45,0,0,1,117.77,35V29.86a1.11,1.11,0,0,1,2.22,0v4.41h-.51V29.86a.6.6,0,1,0-1.2,0V35a.94.94,0,1,0,1.88,0V28.7a1.37,1.37,0,1,0-2.74,0v1.37h-.51V28.7a1.89,1.89,0,0,1,3.77,0V35A1.46,1.46,0,0,1,119.22,36.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 97.99,
    y: 43.36,
    width: 15.94,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 97.99,
    y: 48.76,
    width: 15.94,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 97.99,
    y: 54.16,
    width: 15.94,
    height: 1.54
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforceSwevenImg);
export default __webpack_public_path__ + "static/media/salesforce-sweven-img.336308564d57da23af3b5a3871279d30.svg";
export { ForwardRef as ReactComponent };